import './styles/index.scss'
import HolyStars from './root'
export { HolyStars }
export default HolyStars
